import actionTypes from '../constants/action-types';

const extensions = (state = [], action) => {
  if (action.type === actionTypes.REGISTER_EXTENSION) {
    const { extension } = action.payload;
    // Add extension slug property to each control
    if (extension.ui && extension.ui.control) {
      extension.ui.control.forEach((control) => {
        // eslint-disable-next-line no-param-reassign
        control.extensionSlug = extension.slug;
      });
    }
    return [...state, extension];
  }

  if (action.type === actionTypes.UPDATE_EXTENSION) {
    const { slug, updates } = action.payload;

    return state.map((extension) => {
      if (extension.slug !== slug) {
        return extension;
      }
      return { ...extension, ...updates };
    });
  }

  return state;
};

export default extensions;
